import React from 'react'
import './form.styles.scss'

const ChangePasswordForm = (props) => {
    return (
        <form>
            <div className="inputs">
            <div className="row">
                    <div className="form-label">
                        <label>Current Password</label>
                    </div>
                    <div className="form-input">
                        <input type="password" name="currentPassword" value={props.currentPassword} onChange={props.onChange} />
                        <span className="error">{props.errors.currentPassword}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>New Password</label>
                    </div>
                    <div className="form-input">
                        <input type="password" name="password" value={props.password} onChange={props.onChange} />
                        <span className="error">{props.errors.password}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Confirm New Password</label>
                    </div>
                    <div className="form-input">
                        <input type="password" name="confirmPassword" value={props.confirmPassword} onChange={props.onChange} />
                        <span className="error">{props.errors.confirmPassword}</span>
                    </div>
                </div>
            </div>
            <div className="actions">
                <button type="submit" onClick={props.onSubmit}>Update</button>
            </div>
        </form>
    )
}

export default ChangePasswordForm